import {
  ChecklistFieldDef,
  ChecklistSectionDef,
} from "./DynamicChecklistManagement";

export function fieldSourceKey(sectionId: string, fieldId: string, groupId?: string): string {
  return groupId ? `dg:${sectionId}:${groupId}:${fieldId}` : `field:${sectionId}:${fieldId}`;
}

export function bulkPickerScopeKey(sectionId: string, groupId?: string): string {
  return groupId ? `bulk:${sectionId}:${groupId}` : `bulk:${sectionId}`;
}

export function fieldKeyMatchesScope(key: string, sectionId: string, groupId?: string): boolean {
  if (groupId) return key.startsWith(`dg:${sectionId}:${groupId}:`);
  return key.startsWith(`field:${sectionId}:`);
}

export function resolveFieldIdsFromSourceKeys(
  sourceKeys: string[]
): { sectionId: string; groupId?: string; fieldId: string }[] {
  const out: { sectionId: string; groupId?: string; fieldId: string }[] = [];
  sourceKeys.forEach((key) => {
    if (key.startsWith("field:")) {
      const [, sectionId, fieldId] = key.split(":");
      if (sectionId && fieldId) out.push({ sectionId, fieldId });
      return;
    }
    if (key.startsWith("dg:")) {
      const [, sectionId, groupId, fieldId] = key.split(":");
      if (sectionId && groupId && fieldId) out.push({ sectionId, groupId, fieldId });
    }
  });
  return out;
}

export type DuplicateTargetOption = { value: string; label: string };

export function resolveFieldFromSourceKey(
  sourceKey: string,
  master: ChecklistSectionDef[]
): ChecklistFieldDef | undefined {
  if (sourceKey.startsWith("field:")) {
    const [, sId, fId] = sourceKey.split(":");
    return master.find((s) => s.id === sId)?.fields.find((f) => f.id === fId);
  }
  if (sourceKey.startsWith("dg:")) {
    const [, sId, gId, fId] = sourceKey.split(":");
    const sec = master.find((s) => s.id === sId);
    const g = sec?.repeatableGroups?.find((x) => x.id === gId);
    return g?.fields.find((f) => f.id === fId);
  }
  return undefined;
}

/** Swap order with adjacent field; returns new sorted array or null if no move. */
export function reorderAdjacentFields(
  fields: ChecklistFieldDef[],
  fieldId: string,
  direction: -1 | 1
): ChecklistFieldDef[] | null {
  const sorted = [...fields].sort((a, b) => a.order - b.order);
  const idx = sorted.findIndex((f) => f.id === fieldId);
  const j = idx + direction;
  if (idx < 0 || j < 0 || j >= sorted.length) return null;
  const a = sorted[idx];
  const b = sorted[j];
  return fields
    .map((f) => {
      if (f.id === a.id) return { ...f, order: b.order };
      if (f.id === b.id) return { ...f, order: a.order };
      return f;
    })
    .sort((x, y) => x.order - y.order);
}
